/* eslint-disable import/no-cycle */
import React from 'react';
import { Button, Icons } from '@components';
import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { mdiAccountAlertOutline, mdiFileDocumentAlertOutline } from '@mdi/js';

export const ListagemPendencia = ({ nome, pendencias, setPendenciaAtiva }) => {
  return (
    <>
      <p className="ts-24 mb-1 fw-bold text-orange">Olá, {nome}</p>
      <p className="ts-24 fw-bold">
        Identificamos que você possui tarefas em aberto dentro do Portal Forluz!
      </p>
      <hr className="my-3" />
      <h4 className="fw-bold">
        Para acessar as funcionalidades normalmente conclua os itens listados
        abaixo:
      </h4>
      <List>
        {pendencias.TermoConsentimento > 0 && ( // > 0
          <ListItem className="mt-2">
            <ListItemIcon>
              <Icons
                path={mdiFileDocumentAlertOutline}
                color="var(--primary-color)"
                size={1.5}
              />
            </ListItemIcon>
            <Box sx={{ display: 'flex', width: '70%' }}>
              <ListItemText
                primary={<strong>Termo de Consentimento</strong>}
                secondary="Ao acessar esse termo, você concorda em cumprir os termos de uso, incluindo as políticas de privacidade e segurança. O uso não autorizado pode resultar em sanções."
              />
            </Box>
            <Box sx={{ display: 'flex', width: '30%' }}>
              <Button onClick={() => setPendenciaAtiva('assinaturaDoc')}>
                Resolver
              </Button>
            </Box>
          </ListItem>
        )}
        {pendencias.AtualizacaoCadastral > 0 && ( // > 0
          <ListItem className="mt-2">
            <ListItemIcon>
              <Icons
                path={mdiAccountAlertOutline}
                color="var(--primary-color)"
                size={1.5}
              />
            </ListItemIcon>
            <Box sx={{ display: 'flex', width: '70%' }}>
              <ListItemText
                primary={<strong>Confirmação de Dados Cadastrais</strong>}
                secondary="Para manter seus dados sempre atualizados, pedimos que confirme se as informações do seu cadastro estão corretas. Caso já estejam atualizadas, faça a confirmação na próxima tela."
              />
            </Box>
            <Box sx={{ display: 'flex', width: '30%' }}>
              <Button onClick={() => setPendenciaAtiva('atualizacaoCadastral')}>
                Resolver
              </Button>
            </Box>
          </ListItem>
        )}
        {/* {pendencias.NecessarioResetSenha > 0 && (
          <ListItem className="mt-2">
            <ListItemIcon>
              <Icons
                path={mdiLockAlert}
                color="var(--primary-color)"
                size={1.5}
              />
            </ListItemIcon>
            <Box sx={{ display: 'flex', width: '70%' }}>
              <ListItemText
                primary={<strong>Reset de senha</strong>}
                secondary="Por motivos de segurança, é necessário redefinir sua senha a cada 3 anos. Essa medida ajuda a proteger suas informações contra acessos não autorizados e mantém sua conta segura."
              />
            </Box>
            <Box sx={{ display: 'flex', width: '30%' }}>
              <Button onClick={() => setPendenciaAtiva('resetSenha')}>
                Resolver
              </Button>
            </Box>
          </ListItem>
        )} */}
      </List>
    </>
  );
};
